<template>
  <div class="feed_detail">
    <van-nav-bar
      title="帮助与反馈"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="detail">
      <div class="question">
        <p class="commit_at">{{formatDate(detail.created_at)}}</p>
        <div class="content">{{detail.content}}</div>
        <div class="images" v-if="detail.images.length > 0">
          <van-row gutter="20">
            <van-col span="8" v-for="(src, key) in detail.images" :key=key>
              <van-image
                width="106px"
                height="106px"
                fit="cover"
                lazy-load
                :src=src
              />
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="answer" v-if="detail.reply_content">
        <div class="content">
          <span>[回复]:</span>{{detail.reply_content}}
        </div>
        <div class="reply_at">
          {{formatDate(detail.reply_at)}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Image as VanImage, Lazyload, Col, Row } from 'vant'
Vue.use(NavBar).use(VanImage).use(Lazyload).use(Col).use(Row);

export default {
  created() {
    this.itemid = this.$route.query.itemid
    this.getDetail()
  },
  data() {
    return {
      userid: this.$g.getCookie('userid'),
      itemid: '',
      detail: {}
    }
  },
  methods: {
    onClickLeft: function () {
      this.$router.push({path: '/feedback/record'})
    },
    getDetail: function() {
      const params = {
        userid: this.userid,
        id: this.itemid
      }
      this.$http.get('/api/user_web/get_feedback', {params: params}).then((res) => {
        this.detail = res.data
      })
    },
    formatDate: function(timestamp) {
      timestamp = parseInt(timestamp * 1000)
      let date = new Date(timestamp)
      return this.$g.formatDateTime(date, "yyyy-MM-dd hh:mm:ss")
    }
  }
}
</script>

<style lang="less" scoped>
.feed_detail {
  display: block;
  width: 100%;
  max-width: 3.75rem;
  min-height: 100vh;
  overflow: hidden;

  .detail {
    display: block;
    width: 3.43rem;
    margin: 0 auto;
    overflow: hidden;

    .question {
      display: block;

      .commit_at {
        font-size: 12px;
        color: #999999;
        margin: .16rem 0;
      }
      .content {
        display: block;
        font-size: 16px;
        color: #333333;
        margin-bottom: .16rem;
      }
    }
    .answer {
      display: block;
      width: calc(100% - .32rem);
      margin-top: .16rem;
      background: #FAFAFA;
      border-radius: 4px 2px 2px 2px 4px 4px 4px;
      padding: .16rem;
      overflow: hidden;

      .content {
        display: block;
        width: 100%;
        font-size: 14px;
        color: #2A2A2A;
        overflow: hidden;

        span {
          color: #FF7F4B;        
        }
      }
      .reply_at {
        font-size: 12px;
        color: #999999;
        margin-top: .16rem;
      }
    }
  }
  /deep/ .van-empty__image {
    width: .65rem;
    height: .65rem;
  }
  /deep/ .van-nav-bar{
    margin-top: .26rem;
  }
  /deep/.van-icon {
    color: #666666;
  }
  /deep/.van-nav-bar__title {
    font-size: 18px;
    color: #333333;
  }
}
</style>

